import { Injectable, Injector, Component, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import { RequestModel } from '../../models/request/request-model';
import { RestProviderService } from '../rest-provider/rest-provider.service';
import { SemDynamicComponent } from '../../shared/components/sem-dynamic/sem-dynamic.component';
import { NavigationRequestModel } from '../../models/navigation/navigation-request-model';
import { DynamicLoadingUtil } from '../../shared/helpers/dynamic-loading-util';
import { NavigationNodeSerializer } from '../../models/serializing/navigation-node-serializer';
import { NavigationResponseModel } from '../../models/navigation/navigation-response-model';
import { FileUploadService } from '../file-upload-service/file-upload.service';


import { TranslationsProviderService } from '../translations-provider/translations-provider.service';

import { firstValueFrom } from 'rxjs';
import { environment } from 'src/environments/environment';
import { DynamicFieldsManagerService } from '../dynamic-fields/dynamic-fields-manager.service';
import { LocalStorageService } from '../local-storage-service/local-storage.service';
import { HttpClient } from '@angular/common/http';
import { FileUploadStandaloneService } from '../file-upload-standalone/file-upload-standalone.service';

import { TemplateAssemblyService } from '../dynamic-compilation/template-assembly.service';
import { DynamicCompilationService } from '../dynamic-compilation/dynamic-compilation.service';


@Injectable({
  providedIn: 'root'
})
export class RouteNavigationService {
  private _configData: any;
  private _promise: Promise<any>;
  private _promiseDone: boolean = false;
  private masterPages: any[] = [];
  public wgRoutes: any[] = [];
  public loadedRoutes: any[] = [];
  public leftMenuNodes: any[] = [];
  public loadedRoute: any = null;
  public isPageInHalf: boolean = false;

  masterPage: string;
  masterPageUrl: string;
  private masterPageCache = new Map<string, string>();

  constructor(private localStorageService: LocalStorageService, private http: HttpClient, private model: RequestModel, private restProvider: RestProviderService, private injector: Injector, public fileUploadService: FileUploadService, public translationsService: TranslationsProviderService, public dfms: DynamicFieldsManagerService, private templateAssembly: TemplateAssemblyService, private dynamicCompilation: DynamicCompilationService) { }

  private async fetchMasterPage(url: string): Promise<any> {
    if (this.masterPageCache.has(url)) {
      return this.masterPageCache.get(url);
    }
    const template = await firstValueFrom(this.restProvider.getDataGET(url));
    this.masterPageCache.set(url, template as any);
    return template;
  }

  async reloadApplicationLeftMenu() {
    let request = new NavigationRequestModel();
    this.model.url = "/api/navigation/getNodes";
    request.context = "left-menu";
    request.depth = 0;
    request.rootNode = null;
    this.model.data = request;

    try {
      const data = await firstValueFrom(
        this.restProvider.getDataPOST<NavigationResponseModel[]>(this.model)
      );
      this.localStorageService.remove("/api/navigation/getNodes_left-menu");
      this.localStorageService.add("/api/navigation/getNodes_left-menu", JSON.stringify(data));
    } catch (error) {
      console.log("Error", error);
    }
  }

  loadConfig(url: string): Promise<any> {
    if (this._promiseDone) {
      return Promise.resolve();
    }

    let request = new NavigationRequestModel;
    this.model.url = "/api/navigation/getNodes";
    request.context = "left-menu";
    request.depth = 0;
    request.rootNode = null;

    this.model.data = request;

    this.restProvider.serializer = new NavigationNodeSerializer;

    let cacheData = null;

    if (environment.useRouteAndMasterpageCache) {
      cacheData = this.localStorageService.get("/api/navigation/getNodes_left-menu");
    }

    if (cacheData) {
      DynamicLoadingUtil.navigationNodes = JSON.parse(cacheData);
      this.dfms._routesLoaded.next(DynamicLoadingUtil.navigationNodes);
    }
    else {

      this.restProvider.getDataPOST<NavigationResponseModel[]>(this.model).subscribe(
        data => {
          this.localStorageService.add("/api/navigation/getNodes_left-menu", JSON.stringify(data));
          DynamicLoadingUtil.navigationNodes = data;
          this.restProvider.serializer = null;
          this.dfms._routesLoaded.next(data);
        },
        error => {
          console.log("Error", error);
        }
      );
    }

    let routeDoesntExists = true;

    for (let route in this.router.config) {
      if (route["path"] == url) {
        routeDoesntExists = false;
      }
    }

    //console.log("Current routes: ", this.router.config);

    if (routeDoesntExists) {
      return new Promise((resolve, reject) => {


        this.model.url = "api/navigation/getMasterPages";
        this.model.data = new NavigationRequestModel;
        this.model.data.context = environment.wgProfileHost.substring(environment.wgProfileHost.indexOf('//') + 2); //window.location.host;

        this.restProvider.getDataPOST(this.model).subscribe(
          async (data: any[]) => {

            this.masterPages = data;

            this.model.url = "api/navigation/getRoutes";
            let routesJson = this.localStorageService.get("api/navigation/getRoutes");

            if (routesJson != null) {

              data = JSON.parse(routesJson);
              this.wgRoutes = data;
              for (var i = 0; i < data.length; i++) {
                var urlToCompare = data[i]["PrettyUrl"];
                if (urlToCompare == url) {
                  this.loadedRoute = data[i];
                  await this.registerRoute(data[i]);
                  break;
                }
              }

              resolve(true);
            } else {
              this.restProvider.getDataPOST(this.model).subscribe(
                async (data: any[]) => {

                  this.wgRoutes = data;
                  this.localStorageService.add("api/navigation/getRoutes", JSON.stringify(data));

                  for (var i = 0; i < data.length; i++) {
                    var urlToCompare = data[i]["PrettyUrl"];
                    if (urlToCompare == url) {
                      this.loadedRoute = data[i];
                      await this.registerRoute(data[i]);
                      break;
                    }
                  }

                  resolve(true);
                },
                error => {
                  console.log("Error", error);
                  resolve(false);
                }
              );
            }



            //resolve();
          },
          error => {
            console.log("Error loading master pages", error);
            resolve(false);
          }
        );
      });
    }
    else {
      return null;
    }
  }

  get configData(): any {
    return this._configData;
  }

  public get router(): Router { //this creates router property on your service.
    return this.injector.get(Router);
  }

  getCurrentRoute() {
    let routesJson = this.localStorageService.get("api/navigation/getRoutes");

    if (routesJson) {
      let data = JSON.parse(routesJson);
      for (var i = 0; i < data.length; i++) {
        var urlToCompare = data[i]["PrettyUrl"];
        if (urlToCompare == window.location.pathname.substring(1)) {
          return data[i];
        }
      }
    }

    return null;
  }

  async registerRoute(wgRoute): Promise<void> {
    this.masterPageUrl = "/MasterPages/";
    let masterPageLoaded: boolean = false;

    var masterPagePreEl = window.location.pathname.substring(1).split("/")[0];

    for (var i = 0; i < this.masterPages.length; i++) {
      if (this.masterPages[i].Url == masterPagePreEl) {
        this.masterPageUrl += this.masterPages[i].MasterPage;
        masterPageLoaded = true;
        // break: getMasterPages can return duplicate rows for the same Url when the
        // request context is empty (wgProfileHost=""); without this the name gets
        // concatenated twice -> /MasterPages/<Name><Name> -> 500 and no tabs render.
        break;
      }
    }

    const masterPageTemplate = await this.fetchMasterPage(this.masterPageUrl);
    const masterPageInnerTemplate = await this.fetchMasterPage("/MasterPages/" + wgRoute.MasterPage);
    const rawTemplate = await firstValueFrom(this.restProvider.getDataGET(wgRoute.Url));

    this.loadedRoutes.push({ Url: wgRoute.Url, Html: rawTemplate, ExplicitEditMode: wgRoute.ExplicitEditMode });

    this.masterPage = this.templateAssembly.assembleRouteTemplate(
      masterPageTemplate,
      masterPageInnerTemplate,
      rawTemplate,
      wgRoute,
      masterPageLoaded
    );

    const tmpCmp = Component({ standalone: false, template: this.masterPage.toString(), providers: [FileUploadStandaloneService], changeDetection: ChangeDetectionStrategy.Default })(class extends SemDynamicComponent {});

    (<SemDynamicComponent>tmpCmp.prototype).SerializationObjectFormLink = wgRoute.SerializationObjectFormLink;
    (<SemDynamicComponent>tmpCmp.prototype).isRoutePage = true;

    const routes = [{ path: '', component: tmpCmp }];
    const routeModule = await this.dynamicCompilation.createRouteModule(tmpCmp, routes);

    const appRoutes = [...this.router.config];
    appRoutes.push({
      path: wgRoute.PrettyUrl,
      loadChildren: () => routeModule,
      data: { breadcrumb: 'page' }
    });
    this.router.resetConfig(appRoutes);
  }

}


export function configServiceFactory(injector: Injector, configService: RouteNavigationService): Function {
  return () => {

    var router = injector.get(Router);
    var url = window.location.pathname.substring(1);
    router.onSameUrlNavigation = "reload";

    var compExists = false;

    for (var i = 0; i < router.config.length; i++) {
      if (router.config[i]["path"] == url) {
        compExists = true;
        break;
      }
    }

    if (!compExists) {
      return injector.get(RouteNavigationService)
        .loadConfig(url).then(result => {
          if (result === false) {
            const returnUrl = encodeURIComponent(window.location.pathname + window.location.search + window.location.hash);
            setTimeout(() => router.navigateByUrl('/cms/server-unavailable?returnUrl=' + returnUrl), 0);
          }
        });
    }

    return;
  }
}
